import { Button, InlineError, Input } from 'avo-ui'
import Select from 'components/commons/select'
import TabToggle from 'components/commons/tab-toogle'

export const VoucherGenerator = ({
    generatorDetail,
    onChangeGenerator,
    onGenerate,
    errorGenerator,
    duplicateDetail,
    voucherOptions,
    onSearchVoucher,
    onChangeForm,
    errorForm,
    isLoading,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            <TabToggle
                title={'Voucher Duplicator'}
                content={
                    <div className={'flex flex-col space-y-5'}>
                        <div className={'flex space-x-16'}>
                            <div className={'flex-1 flex-col space-y-5'}>
                                <div className={'flex flex-col space-y-3'}>
                                    <div className={'font-semibold text-blue-90 required'}>Character Amount</div>
                                    <Input
                                        type={'number'}
                                        className={'flex-1'}
                                        name={'character_amount'}
                                        placeholder={'Masukkan jumlah karakter'}
                                        value={generatorDetail?.character_amount}
                                        onChange={(item) => onChangeGenerator({ [item?.name]: item?.value })}
                                    />
                                    <InlineError className='mt-2' message={errorGenerator?.character_amount} />
                                </div>
                                <div className={'flex flex-col space-y-3'}>
                                    <div className={'font-semibold text-blue-90 required'}>Total Voucher</div>
                                    <Input
                                        type={'number'}
                                        className={'flex-1'}
                                        name={'total'}
                                        placeholder={'Masukkan total voucher'}
                                        value={generatorDetail?.total}
                                        onChange={(item) => onChangeGenerator({ [item?.name]: item?.value })}
                                    />
                                    <InlineError className='mt-2' message={errorGenerator?.total} />
                                </div>
                            </div>
                            <div className={'flex-1 flex-col space-y-5'}>
                                <div className={'flex flex-col space-y-3'}>
                                    <div className={'font-semibold text-blue-90'}>Prefix</div>
                                    <Input
                                        className={'flex-1'}
                                        name={'prefix'}
                                        placeholder={'Masukkan prefix'}
                                        pattern={/[a-zA-Z0-9\-]+$/}
                                        value={generatorDetail?.prefix}
                                        onChange={(item) => onChangeGenerator({ [item?.name]: item?.value })}
                                    />
                                </div>
                                <div className={'pt-[31px]'}>
                                    <Button className={'flex-1'} title={'Generate Voucher Code'} onClick={onGenerate} />
                                </div>
                            </div>
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Voucher Code</div>
                            <Input
                                className={'flex-1'}
                                name={'new_code'}
                                placeholder={'Masukkan kode voucher'}
                                value={duplicateDetail?.new_code}
                                pattern={/^([a-zA-Z0-9]+,?\s*)+$/}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className='mt-2' message={errorForm?.new_code} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Select Voucher (Duplicate)</div>
                            <Select
                                name={'target_code'}
                                className={'flex-1'}
                                optionsClassName={'max-h-48'}
                                placeholder={'Insert voucher code'}
                                options={voucherOptions}
                                value={duplicateDetail?.target_code}
                                searchable
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                                onSearch={(value) => onSearchVoucher(value)}
                            />
                            <InlineError className='mt-2' message={errorForm?.target_code} />
                        </div>
                    </div>
                }
            />
            <div className={'flex py-3 justify-center'}>
                <Button className={'w-[200px]'} title={'Duplicate Voucher'} loading={isLoading} onClick={onSubmit} />
            </div>
        </div>
    )
}
